module.exports = __webpack_public_path__ + "img/17.15586115.png";